<!-- Facebook right column (desktop) -->
<a class="frc" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
  <app-meta-creative class="frc-image" [src]="data.creative" [kind]="data.creativeKind" slot="cover"></app-meta-creative>
  <div class="frc-copy">
    <div class="frc-headline">{{ headline }}</div>
    <div class="frc-domain">{{ domain }}</div>
  </div>
</a>
